export default __webpack_public_path__ + "static/media/may2023-2.0474a8e6.jpg";